import { createFileRoute, redirect } from "@tanstack/react-router";

/** URL anterior del Detector de Fugas: 301 a la canónica corta. */
export const Route = createFileRoute("/herramientas/analisis-completo")({
  beforeLoad: () => {
    throw redirect({ to: "/detector-de-fugas", statusCode: 301 });
  },
});
